import openApiHttp from "@/utils/request2"
export let payment = (data) => {
    return openApiHttp({
        url: `/pay/stripePay`,
        method: "post",
        data,
    }, true)
}
export let paychapter = (data) => {
    return openApiHttp({
        url: "/user/buyBookIndex",
        method: "post",
        headers: { 'Content-Type': 'application/json' },
        data,
    }, true)
}
export let paychapters = (data) => {
    return openApiHttp({
        url: "/user/buyBookIndexList",
        method: "post",
        headers: { 'Content-Type': 'application/json' },
        data,
    }, true)
}
export let getchapters = (params) => {
    return openApiHttp({
        url: "/user/BookIndexCount",
        method: "get",
        params,
    }, false)
}
export let getexchangeRate = (params) => {
    return openApiHttp({
        url: "/exchange/rate",
        method: "get",
        params,
    }, false)
}